import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DeveloperLayoutRoutes } from './developer-layout.routing';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(DeveloperLayoutRoutes),
    FormsModule,
    NgbModule,
  ]
})

export class DeveloperLayoutModule {}
